module.exports = __webpack_public_path__ + "images/people/support-team@1x-4f83af8ad28b066f95eb62ff71598ed9.webp";